module.exports = __webpack_public_path__ + "static/media/waiter.5b60e040.gif";